import React from 'react';
import PropTypes from 'prop-types';
import { EnvelopeIcon } from '@heroicons/react/24/outline';

export default function UserEmail(props) {
  const { user } = props;

  return (
    <div className="flex space-x-1 items-center text-gray-500 text-sm">
      <EnvelopeIcon className="h-5 w-5" />
      <span>
        {user.data.email || '[None]'}
      </span>
    </div>
  );
};
